import { GenericEvent, isPageLoadEvent } from "types/Events";
import { getEnv } from "utils/env";

const testSites = [
  "imore",
  "livescience",
  "creativebloq",
  "pcgamer",
  "gamesradar",
];

const env = getEnv();

export const shouldEventBatch = (data: GenericEvent) => {
  // not batch for page load event
  if (isPageLoadEvent(data)) {
    return false;
  }

  if (env.ffte) {
    return true;
  }

  return false;
};
